import LoadingDeliveryDetails from './LoadingDeliveryDetails';

export default LoadingDeliveryDetails;
